import { render, staticRenderFns } from "./StudentInterventionLevel.vue?vue&type=template&id=3169bba0"
import script from "./StudentInterventionLevel.vue?vue&type=script&lang=js"
export * from "./StudentInterventionLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports